import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Daily.css';


const Support = () => {
    const navigate = useNavigate();
    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">We're in this Together <br/>You're not Alone</h2>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Mental Wellness Support</h5>
                    <div className="homeBttnContainer supportActions">
                        <button className="homeBttn" onClick={() => {window.open("https://trampolinehealth.circle.so/join?invitation_token=3cff0ae5ec294f740a32bac3219619a5e2e27ed9-a1faea1f-4698-44e9-be22-47c01f9a128d", "_blank");}}>Community Support</button>
                        <button className="homeBttn" onClick={() => {window.open("https://usemotion.com/meet/fernando-bohorquez-ynb/bk4nn1n?d=30", "_blank");}}>Schedule One on One</button>
                        <button className="homeBttn" onClick={() => {navigate('/in-development')}}>Mental Health Hotlines</button>
                    </div>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Technical Support</h5>
                    <div className="homeBttnContainer supportActions">
                        <button className="homeBttn" onClick={() => {navigate('/settings')}}>Settings</button>
                        <button className="homeBttn" onClick={() => {window.open("https://forms.gle/DVWGTTjrHSwCga7F7", "_blank");}}>Bug Report Form</button>
                        <button className="homeBttn" onClick={() => {window.open("mailto:fernando@trampolinehealth.co?subject=App%20Support", "_blank");}}>Support Email</button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Support;